import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "row align-items-end" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { style: {"width":"200px"} }
const _hoisted_11 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_19 = {
  key: 1,
  class: "text-success"
}
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_26 = { class: "dropdown" }
const _hoisted_27 = { class: "dropdown-menu" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("form", {
                class: "search-bg svg-color pt-3 w-100",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
                    onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
                    class: "form-control shadow-none text-black flex-grow-1",
                    placeholder: "Rechercher un inventaire"
                  }, null, 544), [
                    [_vModelText, _ctx.searchTerm]
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("button", {
                    type: "submit",
                    class: "bg-transparent text-primary transition p-0 border-0 ms-2"
                  }, [
                    _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                  ], -1))
                ])
              ], 32)
            ])
          ]),
          (_ctx.point_ventes.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Filtrer par Point de vente ", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.point_vente,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.point_vente) = $event)),
                      options: _ctx.point_ventes,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      placeholder: "Sélectionner un point de vente"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("table", _hoisted_13, [
          _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Référence "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date de début "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date de fin "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Type "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Magasin "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Statut "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
              }, " ACTIONS")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inventaires, (inventaire, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_14, _toDisplayString(inventaire.refInventaire), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.format_date(inventaire.dateDebut)), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.format_date(inventaire.dateFin)), 1),
                _createElementVNode("td", _hoisted_17, [
                  _createElementVNode("div", null, [
                    (inventaire.typeInventaire == 'Partiel')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(inventaire.typeInventaire), 1))
                      : _createCommentVNode("", true),
                    (inventaire.typeInventaire == 'Global')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(inventaire.typeInventaire), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_20, [
                  (inventaire.magasin)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(inventaire?.magasin.nomMagasin), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_22, [
                  (inventaire.statut === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[6] || (_cache[6] = [
                        _createElementVNode("span", { class: "badge badge-primary" }, "Soumise", -1)
                      ])))
                    : _createCommentVNode("", true),
                  (inventaire.statut === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[7] || (_cache[7] = [
                        _createElementVNode("span", { class: "badge badge-danger" }, "En cours", -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _cache[11] || (_cache[11] = _createElementVNode("button", {
                      class: "btn dropdown-toggle btn-primary text-black",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, "Actions", -1)),
                    _createElementVNode("ul", _hoisted_27, [
                      (_ctx.checkPermission('ViewInventaire'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                            _createVNode(_component_router_link, {
                              to: { name: 'DetailInventairePage', params: { id: inventaire.id } },
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);"
                            }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "fa fa-eye lh-1 me-2 position-relative top-1" }, null, -1),
                                _createTextVNode(" Détail ")
                              ])),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (inventaire.statut == 0 && inventaire.typeInventaire == 'Partiel')
                        ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                            (_ctx.checkPermission('EditFicheInventaire'))
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: { name: 'EditeFicheInventaire', params: { id: inventaire.id } },
                                  class: "dropdown-item d-flex align-items-center"
                                }, {
                                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                                    _createElementVNode("i", { class: "fa fa-pencil lh-2 me-2 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Mise à Jour")
                                  ])),
                                  _: 2
                                }, 1032, ["to"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (inventaire.statut == 1 && inventaire.typeInventaire == 'Partiel')
                        ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                            (_ctx.checkPermission('ViewFicheInventairePdf'))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.generatePDF(inventaire))
                                }, _cache[10] || (_cache[10] = [
                                  _createElementVNode("i", { class: "fa fa-print lh-1 me-2 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Télécharger la fiche ")
                                ]), 8, _hoisted_31))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}